import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "28",
  fill: "none",
  viewBox: "0 0 33 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "31",
      height: "27",
      x: "1",
      y: ".5",
      fill: "#F2F4F7",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "31",
      height: "27",
      x: "1",
      y: ".5",
      stroke: "#E4E6EB",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#667085",
      d: "M16.5 22.182a8.18 8.18 0 1 0 0-16.362 8.18 8.18 0 0 0 0 16.362M26.5 14c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10m-7.273 4.013-3.636-3.637V8.091h1.818v5.533l3.104 3.103z"
    }, null, -1)
  ]))]))
}
export default { render: render }